// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__tlfKF","emails":"CreateEditClinics_emails__3WA26","emailTagLabel":"CreateEditClinics_emailTagLabel__ONd3Y"};